import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const NoncePropsSchema = z.object({
  nonceValue: z.instanceof(HexNumber),
})

type NonceProps = z.infer<typeof NoncePropsSchema>

export class Nonce extends ValueObject<NonceProps> {
  /**
   * @returns A 0x-prefixed hex string.
   */
  public getHexValue(): string {
    return this.props.nonceValue.getValue()
  }

  public static create(nonceValue: HexNumber): Nonce {
    const validatedProps = NoncePropsSchema.parse({ nonceValue })
    return new Nonce(validatedProps)
  }
}
